import { SALES_SETTINGS_API } from 'modules/funnels/api/sale-settings-api'
import { SaleSettingsViewInterface } from 'modules/funnels/types/sale-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useSaleSettings(id?: string) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, SaleSettingsViewInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: saleSettings, mutate: mutateSaleSettings } = useSWR(() => {
    if (user && id) {
      return `${SALES_SETTINGS_API}/${id}`
    }
    return null
  }, fetcher)

  return { saleSettings, mutateSaleSettings }
}
